module.exports = __webpack_public_path__ + "img/huaian.78b022d.png";